/** Normalised SVG viewport. The parent container controls the actual rendered size via width/height: 100%. */
export const VIEWBOX_SIZE = 100;
/** Center of the radial bar in viewBox coordinates (used as the origin for all chart geometry). */
export const VIEWBOX_CENTER = VIEWBOX_SIZE / 2;

/** Allowed numeric range (in percent) for all chart values. */
export const CHART_MIN_VALUE = 0;
export const CHART_MAX_VALUE = 100;

/** Rotational offset so the "start" of the arc is visually at the top of the circle. */
export const ROTATION_OFFSET_DEG = -90;
/** Default angular span (in degrees) for the radial bar. */
export const TOTAL_DEGREE_SPAN = 230;
/** Default radius as a proportion of half the viewBox size. */
export const RADIUS_RATIO = 0.95;
/** Base stroke width (in viewBox units) for radial arcs. */
export const STROKE_WIDTH = 3;

/** Number of segments to divide the 0–100 range into. */
export const SEGMENTS = 3;
/** Angular gap (in degrees) between segments to create visual separation. */
export const SEGMENT_GAP_DEGREES = 5;
/** Per-segment styling and numeric range configuration. */
export const SEGMENT_CONFIG = [
  { strokeClass: 'tw-stroke-danger', min: 0, max: 33.5 },
  { strokeClass: 'tw-stroke-info', min: 33.51, max: 66.5 },
  { strokeClass: 'tw-stroke-success', min: 66.51, max: 100 },
];

/** Convert polar coordinates (angle in degrees + radius) into x/y in chart space. */
export const polarToCartesian = (angleDeg, radius) => {
  const angleRad = (angleDeg * Math.PI) / 180;

  return {
    x: Math.cos(angleRad) * radius,
    y: Math.sin(angleRad) * radius,
  };
};

/** Build the v-tooltip config object for the industry average marker/legend, or null if not yet visible. */
export const industryAverageTooltip = (value, completed) => {
  if (!completed) {
    return null;
  }

  const formattedValue = value.toFixed(0);

  return {
    content: `<strong>Industry Average: ${formattedValue}/100</strong>
      <br/><br/>
      This benchmark is based on the average score of businesses within the same industry category. 
      Where there is insufficient industry-specific data available, a broader benchmark based on comparable businesses is used instead.
      <br/><br/>
      Use this benchmark as a guide to compare your performance against similar businesses.`,
    html: true,
    theme: 'dark-blue-tooltip',
  };
};

/** Build an SVG path string for an arc between two angles at a given radius. */
export const arcPath = (startAngleDeg, endAngleDeg, radius) => {
  const start = polarToCartesian(startAngleDeg, radius);
  const end = polarToCartesian(endAngleDeg, radius);
  const sweep = endAngleDeg - startAngleDeg;
  const largeArcFlag = sweep > 180 ? 1 : 0;

  return [
    `M ${start.x} ${start.y}`,
    `A ${radius} ${radius} 0 ${largeArcFlag} 1 ${end.x} ${end.y}`,
  ].join(' ');
};
